<template>
  <div
    ref="allClassify"
    class="all-classify"
    :class="{'swipe-left':allClassifyShow,'swipe-right':allClassifyHidden}"
    :style="{width:width}"
  >
    <div
      class="head"
      ref="dallClassifyHead"
    >
      <div class="tilte">全部</div>
      <div
        class="left-arrows"
        @click="onClickAllClassifyHidden"
      ></div>
    </div>
    <div
      class="content-container"
      :style="{height:height}"
    >
      <ScrollView
        ref="contentScroll"
        class="scroll-view-wrapper tran"
        :bounce="false"
      >
        <div class="content">
          <div
            v-for="(item, index) in secondCateList"
            :key="index"
            class="classify-container "
            :class="{active:item.itemSecondCateCd==defaultSecondCate.itemSecondCateCd}"
            @click="onClickDefaultSecondCate(item)"
            :clstag="'jr|keycount|jdjr_search_classify|erjifenlei'+item.itemSecondCateCd"
          >
            <div class="classify-content">{{item.itemSecondCateName}}</div>
          </div>
        </div>
      </ScrollView>
    </div>

  </div>
</template>

<script>
import ScrollView from '@/components/ScrollView.vue';
export default {
  name: 'AllClassify',
  components: {
    ScrollView
  },
  data() {
    return {
      height: '100%'
    };
  },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    allClassifyShow: {
      type: Boolean,
      default: false
    },
    allClassifyHidden: {
      type: Boolean,
      default: false
    },
    secondCateList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    defaultSecondCate: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {},
  created() {},
  methods: {
    onClickAllClassifyHidden() {
      this.$emit('onClickAllClassifyHidden');
    },
    showContentHeight() {
      const heightHead = $(this.$refs.dallClassifyHead).height();
      this.height = `${$(document).height() - heightHead}px`;
    },

    onClickDefaultSecondCate(value) {
      console.log(value);
      this.$parent.onClickDefaultSecondCate(value);
      this.onClickAllClassifyHidden();
    }
  },
  mounted() {
    this.showContentHeight();
  },
  destroyed() {
    this.$refs = null;
    this._self = null;
  }
};
</script>

<style lang="scss">
@import '@/scss/mixin.scss';
.all-classify {
  position: absolute;
  left: 100%;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 2002;
  background: #ffffff;
  overflow-y: auto;
  overflow-scrolling: touch;
  -webkit-overflow-scrolling: touch;

  .head {
    background: #ffffff;
    .tilte {
      font-family: PingFangSC-Regular;
      font-size: $rem34;
      color: #333333;
      text-align: center;
      padding: $rem40 0;
      line-height: $rem48;
      border-bottom: 1px solid #cccccc;
    }
    .left-arrows {
      width: $rem19;
      height: $rem34;
      position: absolute;
      left: $rem30;
      top: $rem47;
      background-image: url('//img12.360buyimg.com/jrpmobile/jfs/t26182/267/1432972872/798/3a751089/5be3e578N60438c8b.png');
      background-repeat: no-repeat;
      background-position: 0 0;
      background-size: 100% 100%;
      content: '';
    }
  }
  &.swipe-left {
    transform: translate3d(-100%, 0, 0);
    transition: transform 0.5s ease-out;
  }
  &.swipe-right {
    transform: translate3d(0, 0, 0);
    transition: transform 0.5s ease-out;
  }
  .content-container {
    height: 100%;
    overflow: hidden;
    background: #ffffff;
    .content {
      width: 100%;
      background: #ffffff;
      // overflow-y: auto;
      // overflow-scrolling: touch;
      // -webkit-overflow-scrolling: touch;
      .classify-container {
        width: 100%;
        padding: $rem30 $rem134 $rem30 $rem30;
        position: relative;
        border-bottom: 1px solid #eeeeee;
        color: #333333;

        &.active {
          color: #c29451;

          &::after {
            position: absolute;
            top: $rem30;
            right: $rem32;
            width: $rem32;
            height: $rem32;
            background-image: url('//img12.360buyimg.com/jrpmobile/jfs/t1/392/8/11677/897/5bcee93dEa0df55d2/b515904f911135b1.png');
            background-repeat: no-repeat;
            background-position: 0 0;
            background-size: 100% 100%;
            content: '';
          }
        }
        .classify-content {
          font-family: PingFangSC-Regular;
          font-size: $rem28;
          letter-spacing: 0;
          line-height: $rem32;
        }
      }
    }
  }
}
</style>
